import React, { useState } from 'react'
import CustomColumn from '../../../../../../customControl/CustomColumn';
import { onlyAlphabets } from '../../../../../commonClass/CommonValidation';

const WhatyougetItem = (
    { title, id, placeholder, maxLength, maxCollectionCount,
        keyName, WhatYouGetList, setWhatYouGetList, setWhatYouGetDelete,
        isRequired, formErrors, setFormErrors, disabled, setEditDisabled
    }) => {

    const defaultFormValue = {
        SeqNo: 0,
        ActivityRuleDetailId: 0,
        RuleDetails: ""
    }
    const [formValue, setFormValue] = useState(defaultFormValue);

    //#region on change function
    const handleOnChange = (name, value) => {
        setEditDisabled(false);
        setFormErrors(null);
        setFormValue((prev) => ({ ...prev, [name]: value }));
    }
    //#endregion

    //#region validations
    const validations = () => {
        let status = true;
        let error = {};

        if (formValue?.RuleDetails?.trim()?.length <= 0 || !formValue?.RuleDetails) {
            error[`RuleDetails${keyName}`] = "Input is Mandatory, Cannot leave blank";
        }
        if (formValue?.RuleDetails?.trim()?.length > 0 && WhatYouGetList?.[keyName]?.length >= maxCollectionCount) {
            error[`maxLimit${keyName}`] = `Maximum limit reached. You can add up to ${maxCollectionCount} ${title?.toLowerCase()}.`;
        }
        setFormErrors(error);

        if (Object.keys(error)?.length > 0) {
            status = false;
            const id = Object.keys(error)?.[0];
            document.getElementById(id)?.focus();
        }

        return status;
    }
    //#endregion

    //#region add/remove functions
    const handleRuleAdd = () => {
        if (validations()) {
            setWhatYouGetList((prev) => ({
                ...prev,
                [keyName]: [...prev?.[keyName], { ...formValue, SeqNo: WhatYouGetList?.[keyName]?.length + 1 }]
            }))
            setFormValue(defaultFormValue);
            setEditDisabled(false);
        }
    }

    const handleRuleRemove = (seqno, id) => {
        if (!disabled) {
            setEditDisabled(false);
            setFormErrors(null);
            setWhatYouGetDelete((prev) => ([...prev, id]))
            setWhatYouGetList((prev) => ({
                ...prev,
                [keyName]: WhatYouGetList?.[keyName]?.filter((prev) => prev?.SeqNo !== seqno)?.map((obj, index) => { obj.SeqNo = index + 1; return obj; })
            }))
        }
    }
    //#endregion

    return (
        <>
            <div className="row">
                <CustomColumn colNum={10} labelText={title} labelId={id} isRequired={isRequired} >
                    <input
                        type="text"
                        className='form-control'
                        id={`RuleDetails${keyName}`}
                        value={formValue?.RuleDetails}
                        onChange={(e) => handleOnChange("RuleDetails", onlyAlphabets(e.target.value))}
                        disabled={disabled ? true : false}
                        placeholder={placeholder}
                        maxLength={maxLength}
                    />
                    <div className="whatyougetlist">
                        {
                            WhatYouGetList?.[keyName]?.map((item) => (
                                <div key={item?.SeqNo} className='chips'>
                                    <div className="cross"> <i className={`fa fa-close ${!disabled && "cursor_pointer"}`} onClick={() => handleRuleRemove(item?.SeqNo, item?.ActivityRuleDetailId)} /> </div>
                                    <div className="name" title={item?.RuleDetails} > {item?.RuleDetails?.length > 5 ? `${item?.RuleDetails?.slice(0, 5)}...` : item?.RuleDetails} </div>
                                </div>
                            ))
                        }
                    </div>
                    {formErrors?.[`RuleDetails${keyName}`] && <div className="text-danger text-start fs_14">{formErrors?.[`RuleDetails${keyName}`]}</div>}
                    {formErrors?.[`maxLimit${keyName}`] && <div className="text-danger text-start fs_14">{formErrors?.[`maxLimit${keyName}`]}</div>}
                    {formErrors?.[keyName] && <div className="text-danger text-start fs_14">{formErrors?.[keyName]}</div>}
                </CustomColumn>

                <div className="col-lg-2 col-md-2 col-sm-12 col-12 text-md-start text-center">
                    <button
                        type="button"
                        className='btn btn-primary'
                        disabled={disabled}
                        onClick={() => handleRuleAdd()}
                    >
                        Add
                    </button>
                </div>
            </div>



        </>
    )
}

export default WhatyougetItem